<template lang="pug">
  #member-center-admin-create-new-email
    WtTile(parent :col="12" child-class="")
      .columns.is-multiline.is-variable
        .column.max-width-100
          WtTile.pl-0(child vertical :col="12")
            .columns.is-multiline.is-variable
              .column.max-width-100
                BField.superadmin-border(v-if="$auth.user().isWtAdmin")
                  template(slot="label")
                    span.has-text-danger.has-text-weight-bold SuperAdmin Mass Email:
                    WtTooltip(text="Sent to members subscribed or unsubscribed.")
                  BRadio(v-model="emailFilter" native-value="allMembersInActivePrograms")
                    | All members in active programs who have logged in within the past 365 days.
                BField
                  template(slot="label")
                    | Send email to:
                    WtTooltip(:text="sendEmailTooltip")
                  BRadio(v-model="emailFilter" native-value="allMembers")
                    | All registered walkers:
                    span.has-text-weight-bold {{ emailStats.allMembers }}
                    | who have 'receive emails from admin' turned on.
                //- BField
                  BRadio(v-model="emailFilter" native-value="notInTeam")
                    | Not currently in a team
                BField
                  BRadio(v-model="emailFilter" native-value="atRiskMembers")
                    | At risk walkers:
                    span.has-text-weight-bold {{ emailStats.atRiskMembers }}
                    | who have not logged in for over 30 days and have 'receive emails from admin' turned on
                BField
                  BRadio(v-model="emailFilter" native-value="teamAdmins")
                    | Team Leaders:
                    span.has-text-weight-bold {{ emailStats.teamAdmins }}
                    | TEAM LEADERS in the program
                BField
                  BRadio(v-model="emailFilter" native-value="organizationAdmins")
                    | Organization Admins:
                    span.has-text-weight-bold {{ emailStats.organizationAdmins }}
                    | ORGANIZATION ADMINS in the program
                BField
                  BRadio(v-model="emailFilter" native-value="inFeaturedChallenge")
                    | In a Featured Challenge
                BAutocomplete.autocomplete.filter-select-bottom-margin(
                  v-if="emailFilter === 'inFeaturedChallenge'"
                  :data="featuredChallenges"
                  :open-on-focus="true"
                  :clearable="true"
                  placeholder="Select featured challenge..."
                  dropdown-position="bottom"
                  ref="inFeaturedChallengeSelect"
                  @select="value => handleChallengeSelect(value, 'inFeaturedChallengeSelect')"
                )
                  template(slot-scope="props")
                    .media
                      .media-content
                        .content
                          div.ellipsis {{(props.option.name)}}
                BField
                  BRadio(v-model="emailFilter" native-value="notInFeaturedChallenge")
                    | Not in a Featured challenge
                BAutocomplete.autocomplete.filter-select-bottom-margin(
                  v-if="emailFilter === 'notInFeaturedChallenge'"
                  :data="featuredChallenges"
                  :open-on-focus="true"
                  :clearable="true"
                  placeholder="Select featured challenge..."
                  dropdown-position="bottom"
                  ref="notInFeaturedChallengeSelect"
                  @select="value => handleChallengeSelect(value, 'notInFeaturedChallengeSelect')"
                )
                  template(slot-scope="props")
                    .media
                      .media-content
                        .content
                          div.ellipsis {{(props.option.name)}}

                .block
                  WtButton(
                    is-text
                    color="primary"
                    @click.native="showMemberSearch = true"
                    v-if="!showMemberSearch"
                  ) Add Members Individually
                  WtButton(
                    is-text
                    color="primary"
                    @click.native="showMemberSearch = false"
                    v-else
                  ) Cancel

              .column.is-12.search-columns(v-show="showMemberSearch")
                .recipients.is-bordered.box
                  BField
                    BAutocomplete(
                      rounded
                      icon="magnify"
                      :data="memberSearchResultFiltered"
                      placeholder="Search by email address..."
                      keep-first
                      @typing="onSearch"
                      @select="member => selectedMembers.push(member)"
                      :loading="searchingMembers"
                    )
                      template(slot-scope="props")
                        | {{ props.option.email }}

                  BCheckbox(type="is-info" v-model="useCSV")
                    | Use CSV ( Enter emails separated by commas or new lines, up to 100 emails at a time )
                  BInput.csv-content-margin(
                    v-if="useCSV"
                    v-model="csvContent"
                    name="discussion"
                    placeholder="e.g: email1@example.com, email2@example.com\n email3@example.com"
                    type="textarea"
                    @input="highlightEmails"
                  )
                  .highlighted-emails(v-if="highlightedEmails.length > 0 && useCSV")
                    BTaglist
                      BTag(
                        v-for="(email, index) in highlightedEmails"
                        :key="index"
                        type="is-primary"
                        closable
                        @close="removeHighlightedEmail(index)"
                      )
                        | {{ email }}
                  .block(v-if="highlightedEmails.length > 0 && useCSV")
                    .ml-auto
                      WtButton.csv-content-margin(
                        color="primary"
                        bold
                        size="medium"
                        :disabled="highlightedEmails.length > 100"
                        @click.native="validateAndAddEmails"
                      ) Validate and Add Emails
                  .block(v-if="selectedMembers.length > 0")
                    BField(label="Recipients:")
                      BTaglist
                        BTag(
                          v-for="(member, index) in selectedMembers"
                          :key="member.id"
                          type="is-primary"
                          closable
                          @close="removeMember(index)"
                        )
                          | {{ member.email }}

              //- TODO maybe later
              //- .columns
              //-   .column
              //-     BField.animated.fadeIn
              //-       BSelect(
              //-         placeholder="Select a template"
              //-         expanded
              //-         v-model="selectedTemplate"
              //-       )
              //-         option(
              //-           v-for="template in templates"
              //-           :key="template.id"
              //-           :value="template"
              //-         )
              //-           | {{ template.subject }}
          WtTile.pr-0(child vertical :col="12")
            .columns.animated.fadeIn.is-variable.is-multiline(
              v-if="selectedTemplate"
            )
              .column.is-12
                //- Subject
                BField(label="Subject")
                  BInput(name="subject"  v-model="subject" maxlength="110")
                //- Body
              .column.is-12
                BField
                  template(slot="label")
                    span Body
                WtWysiwyg#email-wysiwyg.textarea-height(selector="#email-wysiwyg" :content.sync="body")

            .level.is-mobile
              .level-left
                .level-item
                  WtButton(
                    is-text
                    color="lightgrey"
                    size="medium"
                    @click.native="resetForm"
                  ) Reset
              .level-right
                .level-item
                  WtButton(
                    outlined
                    bold
                    size="medium"
                    :disabled="!selectedTemplate || !readyToSendEmail"
                    :loading="sendingTestEmail"
                    @click.native="sendTestEmail"
                  ) Send a test email
                .level-item
                  WtButton(
                    color="primary"
                    bold
                    size="medium"
                    :disabled="!selectedTemplate || !readyToSendEmail"
                    :loading="processingEmails"
                    @click.native="send"
                  ) Send
</template>

<script>
import { mapActions } from "vuex";
import { ContentLoader } from "vue-content-loader";
import WtTile from "@@/WtTile/WtTile";
import WtWysiwyg from "@@/WtWysiwyg/WtWysiwyg";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTooltip from "@@/WtTooltip/WtTooltip";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";
import debounce from "lodash/debounce";

export default {
  name: "MemberCenterAdminCreateNewEmail",

  components: {
    WtTile,
    WtWysiwyg,
    WtTooltip,
    WtButton,
    WtTitle,
    WtSwitchQuestionInput,
    ContentLoader
  },
  props: {
    featuredChallenges: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      templates: [],
      selectedTemplate: null,
      body: "",
      subject: "",
      query: "",
      perPage: 5,
      memberSearchResult: [],
      selectedMembers: [],
      searchingMembers: false,
      showMemberSearch: false,
      emailFilter: "",
      error: false,
      processingEmails: false,
      sendingTestEmail: false,
      selectedFeaturedChallenge: null,
      emailStats: {},
      csvContent: "",
      highlightedEmails: [],
      useCSV: false
    };
  },

  computed: {
    sendEmailTooltip() {
      return `
      Emails will not be sent to members who have unsubscribed.
    `;
    },

    memberSearchResultFiltered() {
      return this.memberSearchResult.filter(
        member =>
          !this.selectedMembers.find(smember => smember.id === member.id)
      );
    },

    readyToSendEmail() {
      let featuredChallengeSelected = true;
      if (
        (this.emailFilter === "inFeaturedChallenge" ||
          this.emailFilter === "notInFeaturedChallenge") &&
        !this.selectedFeaturedChallenge
      ) {
        featuredChallengeSelected = false;
      }
      return (
        featuredChallengeSelected &&
        this.subject !== "" &&
        this.body !== "" &&
        (this.emailFilter !== "" ||
          (this.showMemberSearch && this.selectedMembers.length))
      );
    }
  },

  watch: {
    emailFilter(filter) {
      if (filter !== "individualUsers") {
        this.showMemberSearch = false;
        this.selectedMembers = [];
        this.selectedFeaturedChallenge = null;
      }
    },

    selectedMembers(members) {
      if (members.length > 0) {
        this.emailFilter = "individualUsers";
      }
    }
  },

  async mounted() {
    // TODO templates saved for v-later
    // this.templates = await this.fetchTemplates();
    this.fetchEmailStats();
    this.templates = [
      {
        id: "blank",
        subject: "",
        body: ""
      }
    ];
    // TODO temp until we have a select dropdown
    this.selectedTemplate = this.templates[0];
    this.subject = this.templates[0].subject;
    this.body = this.templates[0].body;

    this.onSearch = debounce(async query => {
      if (query[query.length - 1] === " ") {
        return;
      }

      if (query.length === 0) {
        return;
      }

      this.searchingMembers = true;

      const response = await this.searchMembers({
        programId: this.$auth.user().programId,
        query: query,
        perPage: this.perPage
      });

      this.memberSearchResult = response.data;
      this.searchingMembers = false;
    }, 400);
  },

  methods: {
    ...mapActions("emailTemplates", [
      "fetchTemplates",
      "sendEmails",
      "superAdminSendMassEmail"
    ]),
    ...mapActions("program", ["searchMembers"]),
    ...mapActions(["snackBar"]),

    onSearch() {},

    handleChallengeSelect(item, autocompleteRef) {
      if (item) {
        this.$refs[autocompleteRef].setSelected(item.name);
        this.selectedFeaturedChallenge = item.id;
      }
    },

    removeMember(index) {
      this.selectedMembers.splice(index, 1);
    },

    resetForm() {
      this.selectedMembers = [];
      this.emailFilter = "";
      this.showMemberSearch = false;
      // this.selectedTemplate = null; TODO reset selected template when templates are implemented
      this.body = "";
      this.subject = "";
    },

    async send() {
      this.processingEmails = true;

      try {
        let response;
        if (
          this.$auth.user().isWtAdmin &&
          this.emailFilter === "allMembersInActivePrograms"
        ) {
          const formData = {
            filter: this.emailFilter,
            subject: this.subject,
            body: this.body,
            isTest: 0
          };

          let {
            data: {
              data: { memberCount }
            }
          } = await this.axios.get("/super/program-wide-member-count");

          this.$buefy.dialog.confirm({
            title: "Send Mass Email",
            confirmText: "Send Mass Email",
            type: "is-danger",
            hasIcon: true,
            message: `Are you sure you want to send a mass email to ${memberCount} members?`,
            onConfirm: async () => {
              response = await this.superAdminSendMassEmail(formData);
            }
          });
        } else {
          const data = {
            templateId: this.selectedTemplate.id,
            formData: {
              filter: this.emailFilter,
              emails: this.selectedMembers.map(member => member.email),
              subject: this.subject,
              body: this.body,
              isTest: 0,
              featuredChallengeSelected: this.selectedFeaturedChallenge
            }
          };
          response = await this.sendEmails(data);
        }
        if (response && response.data.success) {
          this.snackBar({
            message:
              this.selectedMembers.length > 1
                ? `Emails have been sent.`
                : `Email has been sent.`
          });
          this.resetForm();
        }
      } catch {
        this.error = true;
      }

      this.processingEmails = false;
    },

    async sendTestEmail() {
      this.sendingTestEmail = true;

      try {
        let response;

        if (
          this.$auth.user().isWtAdmin &&
          this.emailFilter === "allMembersInActivePrograms"
        ) {
          const formData = {
            filter: this.emailFilter,
            subject: this.subject,
            body: this.body,
            isTest: 1
          };
          response = await this.superAdminSendMassEmail(formData);
        } else {
          const data = {
            templateId: this.selectedTemplate.id,
            formData: {
              filter: this.emailFilter,
              emails: this.selectedMembers.map(member => member.email),
              subject: this.subject,
              body: this.body,
              isTest: 1,
              featuredChallengeSelected: this.selectedFeaturedChallenge
            }
          };
          response = await this.sendEmails(data);
        }
        if (response && response.data.success) {
          this.snackBar({
            message: `Test email sent to ${this.$auth.user()["email"]}`
          });
        }
      } catch {
        this.error = true;
      }

      this.sendingTestEmail = false;
    },

    async fetchEmailStats() {
      try {
        const programId = this.$auth.user().programId;
        const response = await this.axios.get(`email-stats/${programId}`);
        this.emailStats = response.data.data;
      } catch {
        this.error = true;
      }
    },

    highlightEmails() {
      this.highlightedEmails = this.csvContent
        .split(/[,\n]+/)
        .map(email => email.trim())
        .filter(this.isValidEmail);
    },

    removeHighlightedEmail(index) {
      this.highlightedEmails.splice(index, 1);
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    async validateAndAddEmails() {
      try {
        const programId = this.$auth.user().programId;
        const response = await this.axios.post(`validate-emails/${programId}`, {
          emails: this.highlightedEmails
        });

        const validEmails = response.data.validEmails;
        let invalidEmails = response.data.invalidEmails;

        const newValidEmails = validEmails.filter(email => {
          return !this.selectedMembers.some(member => member.email === email);
        });

        invalidEmails = invalidEmails.filter(
          (email, index) => invalidEmails.indexOf(email) === index
        );

        this.selectedMembers.push(...newValidEmails.map(email => ({ email })));

        this.csvContent = invalidEmails.join(", ");
        this.highlightedEmails = this.csvContent
          .split(/[,\n]+/)
          .map(email => email.trim())
          .filter(this.isValidEmail);
      } catch (error) {
        this.error = true;
      }
    }
  }
};
</script>

<style lang="sass">
#member-center-admin-create-new-email
  .recipients
    padding: 0.75rem

  .search-level
    margin-bottom: .2rem

  .search-columns
    padding-top: 0
  .filter-select-bottom-margin
    margin-bottom: 0.75rem
  .csv-content-margin
    margin-top: 0.75rem
    margin-bottom: 0.75rem
  .max-width-100
    max-width: 100%
  .media-content
    max-width: 100%
  .ellipsis
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  .ellipsis:hover
    text-overflow: clip
    white-space: normal
    word-break: break-all
  .has-text-weight-bold
    font-family: $family-sans-serif-bold
  .highlighted-emails
    .tag
      background-color: #FFA500
  .superadmin-border
    border: 1px solid red
    padding: 1rem
    border-radius: $radius-large
</style>
